export default "__VITE_ASSET__e2fe7104__"